import { render } from "./TopicItem.vue?vue&type=template&id=aa849946&scoped=true"
import script from "./TopicItem.vue?vue&type=script&lang=js"
export * from "./TopicItem.vue?vue&type=script&lang=js"

import "./TopicItem.vue?vue&type=style&index=0&id=aa849946&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa849946"]])

export default __exports__